import MessageIcon from '@mui/icons-material/Message';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import SettingsIcon from '@mui/icons-material/Settings';
import { useRecordModal } from 'hooks/useRecordModal';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useListContext } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { Button } from 'shared/mui/Buttons';

import { useGetOrderAdjustmentTypes } from './hooks/useGetOrderAdjustmentTypes';
import { useSelectedOrders } from './hooks/useSelectedOrders';
import { OrderAdjustmentsExcludeDialog } from './OrderAdjustmentsExcludeDialog/OrderAdjustmentsExcludeDialog';
import { OrderAdjustmentsExcludeGroupDialog } from './OrderAdjustmentsExcludeGroupDialog/OrderAdjustmentsExcludeGroupDialog';
import { OrderAdjustmentsOrder } from './types';

type Props = {
  handleOpenAdjustmentsDialog: VoidFunction;
  handleOpenGroupCommentDialog: VoidFunction;
  handleOrdersExclude: (records: OrderAdjustmentsOrder[]) => void;
};

export const OrderAdjustmentsDatagridBulkActionsToolbar = ({
  handleOpenAdjustmentsDialog,
  handleOpenGroupCommentDialog,
  handleOrdersExclude,
}: Props) => {
  const translate = useTypedTranslate();
  const { selectedIds } = useListContext();
  const selectedOrders = useSelectedOrders();
  const orderAdjustmentTypes = useGetOrderAdjustmentTypes();

  const {
    handleCloseRecordModal: handleCloseAdjustmentsExcludeDialog,
    openRecordModal: openAdjustmentsExcludeDialog,
    handleOpenRecordModal: handleOpenAdjustmentsExcludeDialog,
  } = useRecordModal();
  const {
    handleCloseRecordModal: handleCloseAdjustmentsExcludeGroupDialog,
    openRecordModal: openAdjustmentsExcludeGroupDialog,
    handleOpenRecordModal: handleOpenAdjustmentsExcludeGroupDialog,
  } = useRecordModal();

  const isMultipleIdsSelected = selectedIds?.length !== 1;
  const isAdjustmentAvailable = orderAdjustmentTypes.some((type) => type.isAvailable);

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Button
          disabled={!isAdjustmentAvailable}
          label={translate('app.orderAdjustments.header.adjustmentSettings')}
          onClick={handleOpenAdjustmentsDialog}
          startIcon={<SettingsIcon />}
        />
        <Button
          label={translate('app.orderAdjustments.bulkActions.comment')}
          onClick={handleOpenGroupCommentDialog}
          startIcon={<MessageIcon />}
        />
        <Button
          color="error"
          label={translate('app.orderAdjustments.bulkActions.exclude')}
          onClick={
            isMultipleIdsSelected
              ? handleOpenAdjustmentsExcludeGroupDialog
              : handleOpenAdjustmentsExcludeDialog
          }
          startIcon={<RemoveCircleOutlineIcon />}
        />
      </Box>
      {openAdjustmentsExcludeDialog && (
        <OrderAdjustmentsExcludeDialog
          onClose={handleCloseAdjustmentsExcludeDialog}
          onExclude={() => {
            handleOrdersExclude(selectedOrders);
            handleCloseAdjustmentsExcludeDialog();
          }}
          open={openAdjustmentsExcludeDialog}
          selectedOrder={selectedOrders[0]}
        />
      )}
      {openAdjustmentsExcludeGroupDialog && (
        <OrderAdjustmentsExcludeGroupDialog
          onClose={handleCloseAdjustmentsExcludeGroupDialog}
          onExclude={() => {
            handleOrdersExclude(selectedOrders);
            handleCloseAdjustmentsExcludeGroupDialog();
          }}
          open={openAdjustmentsExcludeGroupDialog}
          selectedOrdersAmount={selectedOrders?.length}
        />
      )}
    </>
  );
};
